import useTagStyles from './useTagStyles';
import { TagWithQcnt } from '../../../../types';
import useGlobalStyles from '../../../useGlobalStyles';

/**
 * Props for the Tag component.
 *
 * t - The tag object.
 * clickTag - Function to handle the tag click event.
 */
interface TagProps {
  t: TagWithQcnt;
  clickTag: (tagName: string) => void;
}

/**
 * Tag component that displays information about a specific tag.
 * The component displays the tag's name, description, and the number of associated questions.
 * It also triggers a click event to handle tag selection.
 *
 * @param t - The tag object .
 * @param clickTag - Function to handle tag clicks.
 */
const TagView = ({ t, clickTag }: TagProps) => {
  const { classes } = useTagStyles();
  const { classes: globalClasses } = useGlobalStyles();

  return (
    <div
      className={classes.tagNode}
      onClick={() => {
        clickTag(t.name);
      }}>
      <div className={classes.tagName}>{t.name}</div>
      <div className={globalClasses.p}>{t.description}</div>
      <div className={classes.tagQuestionCnt}>
        {t.qcnt} {t.qcnt === 1 ? 'question' : 'questions'}
      </div>
    </div>
  );
};

export default TagView;
